export enum Page {
  FreeUpgradeScreen = 'Free Upgrade Screen',
  FreeUpgradeCompleted = 'Free Upgrade Completed Screen',
}

export type TrackingProps = {
  current: string
  next: string
}
